interface Props {
  field?: string | number | null
}

const Percentage = ({ field }: Props) => {
  return field ? `${field}%` : null
}

export default Percentage
